import {
  CustomRentalItemRequest,
  CustomSaleItemRequest,
  RentalItemRequest,
  SaleItemRequest,
} from '../financials/financials';

export type OrderInputRental = RentalItemRequest & {
  assignedUnits: number[];
};

export type OrderInputSale = SaleItemRequest;
export type OrderCustomInput = (CustomSaleItemRequest | CustomRentalItemRequest) & {
  isCustom: true;
  generalLedgerAccountId?: string;
  taxCategoryId?: string;
  equipmentOwner?: string;
};

export type OrderInputItem = OrderInputRental | OrderInputSale | OrderCustomInput;

export const isOrderCustomInput = (item: OrderInputItem): item is OrderCustomInput => {
  return 'isCustom' in item && item.isCustom;
};
export const isSaleInput = (item: OrderInputItem): item is OrderInputSale => {
  return 'type' in item && item.type === 'Sale';
};
